import { Box, Flex } from "@chakra-ui/react";
import Header from '@/components/layout/Header';
import Lateral from '@/components/layout/Lateral';
import Footer from '@/components/layout/Footer';
import Container from '@/components/partials/Container';
import Advertising from '@/components/Advertising';
import Menu from './menu';

export default async function Main({ children, ads, showLateralExtras }) {
  const { navmenu, colormenu } = Menu();

  return (
    <Box fontSize="mg">
      <Advertising ads={ads?.supertopo[0]} padding="0" />

      <Header navmenu={navmenu} colormenu={colormenu} />

      <Container>
        <Box py="4">
          <Advertising ads={ads?.topo[0]} />

          <Flex flexDirection={{ base: 'column', xl: 'row' }} pt="4">
            <Box w="100%">
              { children }
            </Box>

            <Box ml="4" w="100%" maxW={{ base: '100%', xl: '310px' }} display={{ base: 'none', xl: 'block' }}>
              <Lateral ads={ads?.lateral} showLateralExtras={showLateralExtras} />
            </Box>
          </Flex>
        </Box>
      </Container>

      <Footer menu={[...navmenu, ...colormenu]} />
    </Box>
  )
}
